import { Component, OnInit, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import {empty} from '../../functions';
import {LocaleService} from '../../shared/services/locale.service';
import {ValidationService} from '../../shared/services/validation.service';
import {catchError} from 'rxjs/operators';
import {UserService} from '../../shared/services/user.service';
import {Observable, of} from 'rxjs';
import {ModalService} from '../../shared/services/modal.service';
import {RoleTypes} from '../../guards/roletypes';
import {Router} from '@angular/router';
import {AuthenticationService} from '../../shared/services/authentication.service';
import {SchoolService} from '../../api/services/school.service';
import {TeacherProfileService} from '../../api/services/teacher-profile.service';
import {RegisterTeacherProfile} from '../../api/models/register-teacher-profile';
import {School} from '../../api/models/school';
import {SchoolClass} from '../../api/models/school-class';

@Component({
    selector: 'app-teacher-registration',
    templateUrl: './teacher-registration.component.html',
    styleUrls: ['./teacher-registration.component.scss'],
    standalone: false
})
export class TeacherRegistrationComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  isLoggedIn = false;

  public entity = {
    firstName: '',
    lastName: '',
    infix: '',
    address: {
      street: '',
      number: '',
      numberSuffix: '',
      postalCode: '',
      city: '',
      country: '',
    },
    phoneNumber: '',
    allowEmailNotifications: false,
    isSubscribedToNewsletter: false,
  };

  schools: School[] = [];
  schoolClasses: SchoolClass[] = [];
  selectedSchoolId: string = '';
  selectedClassIds: string[] = [];
  hasAcceptedGdprPolicy = false;

  validation:any = {
    validated: false,
    valid: false,
    fields: {
      entity: {
        firstName: {
          regex: 'required',
          error: false
        },
        lastName: {
          regex: 'required',
          error: false
        },
        address: {
          street: {
            regex: 'required',
            error: false
          },
          number: {
            regex: 'required',
            error: false
          },
          city: {
            regex: 'required',
            error: false
          },
          postalCode: {
            regex: 'required',
            error: false
          },
          country: {
            regex: 'required',
            error: false
          }
        },
      }
    }
  }

  /**
   * Constructor
   *
   * @param locale
   * @param authService
   * @param router
   * @param modal
   * @param userService
   * @param teacherService
   * @param validationService
   */
  constructor(public locale: LocaleService,
              private authService: AuthenticationService,
              public router:Router,
              public modal:ModalService,
              private userService: UserService,
              private validationService: ValidationService,
              private schoolService: SchoolService,
              private teacherProfileService: TeacherProfileService) {


  }

  /**
   * On NG init
   */
  ngOnInit(): void {

    this.authService.isAuthenticated$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe( (authenticated) => {

      if (!authenticated) {

        // If not authenticated then login
       // this.authService.Login();

      } else {

        this.isLoggedIn = true;

        // Check if user is authenticated, if not login / register
        this.authService.profile$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe( (profile) => {

          if (profile !== null) {

          } else {

          }

        });

      }

    });

    this.loadSchools();

  }

  loadSchools() {
    this.schoolService.getSchools({ PageSize: 500 }).subscribe((result: any) => {
      if (result?.data) {
        this.schools = result.data;
      }
    });
  }

  onSchoolChange(schoolId: string) {
    this.selectedSchoolId = schoolId;
    this.selectedClassIds = [];
    this.schoolClasses = [];

    if (schoolId) {
      this.schoolService.getSchoolClasses({ schoolId }).subscribe((result: any) => {
        if (result?.data) {
          this.schoolClasses = result.data;
        }
      });
    }
  }

  toggleClass(classId: string) {
    const index = this.selectedClassIds.indexOf(classId);
    if (index > -1) {
      this.selectedClassIds.splice(index, 1);
    } else {
      this.selectedClassIds.push(classId);
    }
  }

  isClassSelected(classId: string): boolean {
    return this.selectedClassIds.includes(classId);
  }

  /**
   * Login
   *
   * @constructor
   */
  Login() {
    this.authService.Login('/teacher/registration');
  }

  /**
   * Show validation error
   *
   * Determine if a validation error needs to be visible to client
   *
   * @param stepNumber
   * @param $entity
   * @param $entityProperty
   */
  showValidationError($entity: string, $entityProperty: string, $property:string = '') {

    if (!empty($property)) {
      if (this.validation['validated']
        && this.validation['fields'].hasOwnProperty($entity)
        && this.validation['fields'][$entity].hasOwnProperty($entityProperty)
        && this.validation['fields'][$entity][$entityProperty].hasOwnProperty($property)
        && this.validation['fields'][$entity][$entityProperty][$property]['error'] === true) {
        return true;
      } else {
        return false;
      }
    } else {
      if (this.validation['validated'] && this.validation['fields'][$entity][$entityProperty]['error'] === true) {
        return true;
      } else {
        return false;
      }
    }

  }

  /**
   * Validate the registration form
   */
  validateForm() {
    let valid = true;
    const self:any = this;

    // Set entity data selectors
    const $entitySelectors = ['entity', 'entity.address'];

    // Check entity columns
    for (const $entitySelector of $entitySelectors) {

      const $entitySplit = $entitySelector.split('.');

      if ($entitySplit.length > 1) {

        const $entitySelectorMain = $entitySplit[0];
        const $entitySelectorSub = $entitySplit[1];

        if ( this.validation['fields'].hasOwnProperty($entitySelectorMain) && this.validation['fields'][$entitySelectorMain].hasOwnProperty($entitySelectorSub) ) {

          for (const key in this.validation['fields'][$entitySelectorMain][$entitySelectorSub]) {

            if (!empty(this.validation['fields'][$entitySelectorMain][$entitySelectorSub][key])) {

              const entity = this.validation['fields'][$entitySelectorMain][$entitySelectorSub][key];

              if (entity.hasOwnProperty('regex') ) {
                const value = self[$entitySelectorMain][$entitySelectorSub][key];
                const regPattern = entity['regex'];

                // Set validation flags
                if (!this.validationService.regexValidation(regPattern, value)) {
                  this.validation['fields'][$entitySelectorMain][$entitySelectorSub][key]['error'] = true;
                  valid = false;

                } else {
                  this.validation['fields'][$entitySelectorMain][$entitySelectorSub][key]['error'] = false;
                }

              }
            }
          }
        }

      } else {

        if ( this.validation['fields'].hasOwnProperty($entitySelector) ) {

          for (const key in this.validation['fields'][$entitySelector]) {

            if (!empty(this.validation['fields'][$entitySelector][key])) {

              const entity = this.validation['fields'][$entitySelector][key];

              if (entity.hasOwnProperty('regex') ) {
                const value = self[$entitySelector][key];
                const regPattern = entity['regex'];

                // Set validation flags
                if (!this.validationService.regexValidation(regPattern, value)) {
                  this.validation['fields'][$entitySelector][key]['error'] = true;
                  valid = false;

                } else {
                  this.validation['fields'][$entitySelector][key]['error'] = false;
                }

              }
            }
          }
        }
      }


    }

    // Set validation flags for step
    this.validation['valid'] = valid;
    this.validation['validated'] = true;

    return valid;
  }

  /**
   * Register user
   *
   * creates account and profile
   *
   * @constructor
   */
  Register() {

    const valid = this.validateForm();

    if (!this.hasAcceptedGdprPolicy) {
      this.modal.Alert('Error', 'Please accept the privacy policy to continue');
      return;
    }

    // Proceed registration of teacher profile
    if (valid) {

      const accountParams = {
        accountType: RoleTypes.Teacher
      };

      const teacherprofileParams: RegisterTeacherProfile = {
        firstName: this.entity.firstName,
        lastName: this.entity.lastName,
        infix: this.entity.infix,
        address: {
          street: this.entity.address.street,
          number: this.entity.address.number,
          numberSuffix: this.entity.address.numberSuffix,
          city: this.entity.address.city,
          postalCode: this.entity.address.postalCode,
          country: this.entity.address.country,
        },
        phoneNumber: this.entity.phoneNumber,
        allowEmailNotifications: this.entity.allowEmailNotifications,
        isSubscribedToNewsletter: this.entity.isSubscribedToNewsletter,
        hasAcceptedGdprPolicy: this.hasAcceptedGdprPolicy,
        preferredLanguage: this.locale.currentLanguage().code,
      };

      // Check current account first
      this.userService.apiGetAccountCurrent().pipe(catchError(this.handleError('apiGetAccountCurrent', null))).subscribe((account) => {

        if (!empty(account)) {
          this.authService.setProfileData(account);

          // Check if we need to create a teacher profile or update
          this.teacherProfileService.getCurrentTeacherProfile().pipe(catchError(this.handleError('apiGetTeacherProfileCurrent', null))).subscribe( (teacherprofileCurrent) => {

            // Update the profile
            if (!empty(teacherprofileCurrent)) {

              // TODO: maybe not update

            }
            else {

              // Create a new profile

              this.teacherProfileService.registerTeacherProfile({ body: teacherprofileParams }).pipe(catchError(this.handleError('apiRegisterTeacherprofile', false))).subscribe( (response: any) => {

                if (response !== false) {

                  this.fetchProfileAndRedirect();

                } else {
                  this.modal.Alert('Error', 'Something went wrong, please try again');
                }

              });

            }

          });

        } else {

          // Create account and teacher profile

          // Step 1: create account

          this.userService.apiAccountRegister(accountParams, 'Teacher').pipe(
            catchError(this.handleError('apiAccountRegister', null))
          ).subscribe( (accountResponse) => {

            // If account is created, create teacher profile
            if (!empty(accountResponse)) {
              this.authService.setProfileData(accountResponse);

              this.teacherProfileService.registerTeacherProfile({ body: teacherprofileParams }).pipe(catchError(this.handleError('apiRegisterTeacherprofile', false))).subscribe( (response: any) => {

                if (response !== false) {

                  this.fetchProfileAndRedirect();

                } else {
                  this.modal.Alert('Error', 'Something went wrong, please try again');
                }

              });

            } else {
              this.modal.Alert('Register', 'Something went wrong, please try again');
            }

          });

        }

      });

    }
  }

  private fetchProfileAndRedirect() {
    this.teacherProfileService.getCurrentTeacherProfile().pipe(
      catchError(this.handleError('apiGetTeacherProfileCurrent', null))
    ).subscribe((profile: any) => {
      if (profile) {
        this.assignSchoolClassesAndRedirect(profile.id);
      } else {
        this.router.navigateByUrl('/profile');
      }
    });
  }

  private assignSchoolClassesAndRedirect(teacherProfileId: string) {
    if (this.selectedClassIds.length > 0) {
      const schoolClassObjects = this.schoolClasses
        .filter(cls => this.selectedClassIds.includes(cls.id!))
        .map(cls => ({ id: cls.id, name: cls.name } as SchoolClass));

      this.teacherProfileService.setTeacherProfileSchoolClasses({
        profileId: teacherProfileId,
        body: schoolClassObjects,
      }).pipe(catchError(this.handleError('setTeacherProfileSchoolClasses', null))).subscribe(() => {
        this.router.navigateByUrl('/profile');
      });
    } else {
      this.router.navigateByUrl('/profile');
    }
  }

  handleError<T>(operation:string = '', result?: T) {
    return (error: any): Observable<T> => {

      // Handle given operation
      switch (operation) {

        case 'apiGetAccountCurrent':
          // Do not perform any action, profile could be non-existing
          break;

        case 'apiGetTeacherProfileCurrent':
          // Do not perform any action, profile could be non-existing
          break;

        case 'apiCreateTeacherprofile':
          // Do not perform any action, profile could be non-existing
          break;

        default:
          this.modal.Alert('Error', 'Something went wrong, please try again');
          break;

      }

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

}
